import React, { useEffect, useState } from "react";
import { Fingerprint } from "lucide-react";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { biometric } from "@/lib/biometric";
import { storage } from "@/lib/storage";

export const BiometricToggle = () => {
  const [supported, setSupported] = useState(null);
  const [on, setOn] = useState(biometric.isEnabled());
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    biometric.isSupported().then(setSupported);
  }, []);

  const toggle = async (next) => {
    if (!next) {
      biometric.disable();
      setOn(false);
      toast.success("Fingerprint unlock turned off");
      return;
    }
    setBusy(true);
    try {
      await biometric.enable(storage.getUser());
      setOn(true);
      toast.success("Fingerprint unlock is on");
    } catch (e) {
      toast.error("Could not set up fingerprint. Try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="card-glass rounded-2xl p-5 mb-6 flex items-center gap-4 fade-slide-up" data-testid="biometric-card">
      <div className="w-12 h-12 rounded-xl bg-[rgba(230,180,85,0.1)] flex items-center justify-center">
        <Fingerprint size={22} className="text-[#E6B455]" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="font-semibold text-[#F7E6B4]">Fingerprint unlock</div>
        <div className="text-xs text-[#F7E6B4]/55" data-testid="biometric-status">
          {supported === false
            ? "Not available on this device"
            : on
              ? "On · your PIN still works as backup"
              : "Open the app with your fingerprint"}
        </div>
      </div>
      <Switch
        checked={on}
        disabled={!supported || busy}
        onCheckedChange={toggle}
        data-testid="biometric-toggle"
        className="data-[state=checked]:bg-[#E6B455] data-[state=unchecked]:bg-[#F7E6B4]/20 disabled:opacity-60"
      />
    </div>
  );
};
